<template>
  <div>
    <BjDrawerForm
      ref="BjDrawerForm"
      :form="form"
      :confirm-dis="isView"
      width="800px"
      label-width="120px"
      @handleConfirm="handleConfirm"
    >
      <BjDivider>{{ $t('AccountManagement.work.info') }}
        <template slot="right">
          <el-button type="primary" :disabled="isView" @click="onAddStaff()">{{ $t('addText') }}</el-button>
        </template>
      </BjDivider>
      <el-form ref="staffList" :model="form" :rules="staffListRules">
        <el-table :data="form.staffList" stripe border>
          <el-table-column type="index" :label="$t('DetailsOfThirdPartySalesOrder.Serial')" align="center" width="60" />
          <el-table-column align="center">
            <template #header>{{ $t('AccountManagement.staff.name') }}</template>
            <template slot-scope="{ row, $index }">
              <el-form-item :prop="`staffList.${$index}.name`" :rules="staffListRules.name" style="margin-top:10px !important;">
                <span>{{ row.name }}</span>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template #header><span class="red">*</span> {{ $t('AccountManagement.work.hour') }}</template>
            <template slot-scope="{ row, $index }">
              <!-- <el-form-item :prop="`staffList.${$index}.workHours`" :rules="staffListRules.workHours" style="margin-top:10px !important;">
                <BjInputMoney v-model="row.workHours" :option-list="staffRoleList" :precision="1" :placeholder="$t('AccountManagement.work.hour')" />
              </el-form-item> -->
              <el-form-item :prop="`staffList.${$index}.staffListHours`" :rules="staffListRules.staffListHours" style="margin-top:10px !important;">
                <el-time-picker
                  v-model="row.staffListHours" format="HH:mm" value-format="yyyy-MM-dd HH:mm:ss" class="full-width" is-range
                  range-separator="-" :start-placeholder="$t('form.startTimeText')" :end-placeholder="$t('form.endTimeText')"
                  :disabled="isView"
                >
                </el-time-picker>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="120">
            <template slot-scope="scope">
              <el-button type="text" :disabled="isView" @click="onDelete(scope.$index)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>

      <BjDivider>{{ $t('AccountManagement.work.Reason') }}</BjDivider>
      <el-col :span="24">
        <el-form-item :label="$t('AccountManagement.work.Reason')" prop="reason">
           <BjInput v-model="form.reason" type="textarea" show-word-limit :maxlength="MAX_LENGTH.PRIORITY" autosize :placeholder="$t('AccountManagement.work.Reason')" clearable :disabled="isView" />
        </el-form-item>
      </el-col>
    </BjDrawerForm>
    <BjLogTableDialog ref="logTable" :query-api="queryApi" :query-params="queryParams" :staff-role-list="staffRoleList" :staff-dept-list="staffDeptList" @onConfirm="onConfirm">
      <template v-slot:baseForm>
        <el-col :span="6">
          <el-form-item :label="$t('AccountManagement.staff.name')" prop="staffName">
            <BjInput v-model="queryParams.staffName" :placeholder="$t('AccountManagement.staff.name')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('AccountManagement.staff.department')" prop="staffDepartment">
            <BjSelectLov v-model="queryParams.staffDepartment" :option-list="staffDeptList" :placeholder="$t('AccountManagement.staff.department')" @change="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
    </BjLogTableDialog>
  </div>
</template>
<script>
import { funConfigApi } from '@/api';
import { mergeOvertimeStaffList } from './actualAllocation';

export default {
  props: {
    // 工种下拉框数据
    staffRoleList: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
    // 工种下拉框数据
    staffDeptList: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      // 父组件传入参数
      department: null,
      workDate: null,
      isView: false,
      // 表单数据
      form: {
        department: null,
        workDate: null,
        staffList: [],
      },
      queryApi: funConfigApi.getWarehouseStaffList,
      queryParams: {
        staffName: null,
        staffDepartment: null,
      },
      // 外包人员必填验证
      staffListRules: {
        staffListHours: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
    };
  },
  methods: {
    getDefaultHours() {
      const datePrefix = this.workDate ? this.workDate.substring(0, 10) : new Date().toISOString().substring(0, 10);
      return [`${datePrefix} 17:30:00`, `${datePrefix} 23:59:00`];
    },
    // 数据回显
    getOverTimeData() {
      const defaultHours = this.getDefaultHours();
      funConfigApi.getWorkforceStaffOvertime({department: this.department, workDate: this.workDate}).then(res => {
        this.form = {
          staffList: res.staffList ? res.staffList.map(item => ({...item, staffListHours: item.staffListHours ? JSON.parse(item.staffListHours) : defaultHours})) : [],
          reason: res.reason || null,
        };
      });
    },
    show(isView = false) {
      this.isView = !!isView;
      this.getOverTimeData();
      this.$refs.BjDrawerForm.setTitle(this.$t('AccountManagement.work.Overtime'));
      this.$refs.BjDrawerForm.show();
    },
    // 新增内部人员
    onAddStaff() {
      if (this.isView) return;
      this.queryParams = {
        staffName: null,
        staffDepartment: null,
      };
      this.$refs.logTable.show();
    },
    // 新增内部人员
    onConfirm(event) {
      if (this.isView) return;
      const defaultHours = this.getDefaultHours();
      this.form.staffList = mergeOvertimeStaffList(this.form.staffList, event, defaultHours);
      setTimeout(() => {
        // 清空内部人员表单验证
        this.$refs.staffList.clearValidate();
      }, 100);
    },
    // 删除
    onDelete(index) {
      if (this.isView) return;
      this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        this.form.staffList.splice(index, 1);
        setTimeout(() => {
          this.$refs.staffList.clearValidate();
        }, 100);
        this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
      });
    },
    // 处理时间数据格式化
    formatTimeData(timeStr, workDatePrefix) {
      const spaceIndex = timeStr.indexOf(' ');
      return workDatePrefix + timeStr.substring(spaceIndex);
    },
    // 增强人员数据：添加 startTime、endTime 字段
    enhanceStaffData(data) {
      const workDatePrefix = data.workDate.substring(0, 10);

      // 处理内部人员列表
      data.staffList.forEach(staff => {
        const updatedHours = staff.staffListHours.map(timeStr =>
          this.formatTimeData(timeStr, workDatePrefix)
        );
        staff.startTime = updatedHours[0];
        staff.endTime = updatedHours[1];
        staff.staffListHours = JSON.stringify(updatedHours);
      });

      return data;
    },
    handleConfirm() {
      if (this.isView) return;
      if (this.form.staffList.length == 0) return this.$message.warning(this.$t('chooseText') + ' ' + this.$t('AccountManagement.work.info'));
      if (!this.form.reason) return this.$message.warning(this.$t('inputText') + ' ' + this.$t('AccountManagement.work.Reason'));
      this.$refs.staffList.validate(valid => {
        if (valid) {
          const API_DATA = {
            department: this.department,
            workDate: this.workDate,
            staffList: this.form.staffList,
            reason: this.form.reason,
          };
          // 处理时间数据格式化
          const POST_DATA = this.enhanceStaffData(API_DATA);
          console.log(POST_DATA, 'POST_DATA');
          funConfigApi.addWorkforceStaffOvertime(POST_DATA).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }
          });
        }
      });
    },
    hide() {
      this.$refs.BjDrawerForm.hide();
    },
    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>
